import client from '@/api/client.js';
import jobListApi from '@/api/Methods/Job/Job-List-API-Methods';
import jobStatusApi from '@/api/Methods/Job/Job-Status-API-Methods';
import machinejobApi from '@/api/Methods/Job/Machine-Job-API-Methods';
import jobmixin from '@/helpers/Mixins/JobMixin.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        ...jobStatusApi.methods,
        async getJobTypes() {
            var response = await client().get(store.state.apiRouteRoot + "jobtype", { meta: { clientApiMethod: 'getJobTypes' } })
            return response?.data;
        },
        async GetJobPriorityList() {
            var response = await client().get(store.state.apiRouteRoot + 'jobpriority', { meta: { clientApiMethod: 'GetJobPriorityList' } })
            return response?.data;
        },
        async getJobById(id, oldformat = false) {
            var meta = {
                clientApiMethod: 'getJobById',
                input: { jobId: id, oldformat: oldformat },
                failureText: i18n.t("servicesystem.responses.failed_get_object", { okey: i18n.t("servicesystem.common_objects.job.job").toLowerCase() })
            }
            var methodroute = oldformat ? "job/oldformat/" : "job/";
            var response = await client().get(store.state.apiRouteRoot + methodroute + id, { meta: meta })
            jobmixin.methods.setAgos(response.data);
            return response?.data;
        },
        async createJob(newjob) {
            var meta = {
                clientApiMethod: 'createJob',
                input: { newjob },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.job.job") }),
                failureText: i18n.t("servicesystem.responses.failed_created_object", { okey: i18n.t("servicesystem.common_objects.job.job").toLowerCase() })
            }
            var response = await client().post(store.state.apiRouteRoot + "job/create", newjob, { meta: meta })
            return response?.data;
        },
        async saveJobDetails(jobdetails) {
            var meta = {
                clientApiMethod: 'saveJobDetails',
                input: { jobdetails },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.job") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "job/changedetails", jobdetails, { meta: meta })
            return response?.data;
        },
        async SetJobStatus(jobId, newStatusId, newSubstatusId) {
            var meta = {
                clientApiMethod: 'SetJobStatus',
                input: { jobId: jobId, newStatusId: newStatusId, newSubstatusId: newSubstatusId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.status") })
            }
            const query = '?jobStatusId=' + newStatusId + (newSubstatusId ? ('&jobSubStatusId=' + newSubstatusId) : '');
            var response = await client().patch(store.state.apiRouteRoot + "Job/" + jobId + "/ChangeStatus" + query, null, { meta: meta })
            return response?.data;
        },
        async SetInvoiceCustomer(jobId, customerId, contactId) {
            const query = '?customerId=' + customerId + '&contactId=' + contactId;
            var meta = {
                clientApiMethod: 'SetInvoiceCustomer',
                input: { jobId: jobId, customerId: customerId, contactId: contactId },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.job.invoice_customer") })
            }
            var response = await client().patch(store.state.apiRouteRoot + "Order/Job/" + jobId + "/InvoiceCustomer" + query, null, { meta: meta })
            return response?.data;
        },
        async approveJob(jobId) {
            var meta = {
                clientApiMethod: 'approveJob',
                input: { jobId: jobId },
                successText: i18n.t("servicesystem.responses.approved_job")
            }
            var response = await client().patch(store.state.apiRouteRoot + "job/" + jobId + "/approve", null, { meta: meta })
            return response?.data;
        },
        async deleteParentJob(jobId) {
            var meta = {
                clientApiMethod: 'deleteParentJob',
                input: { jobId: jobId },
                successText: i18n.t("servicesystem.responses.removed_object", { okey: i18n.t("servicesystem.common_objects.job.job") })
            }
            var response = await client().delete(store.state.apiRouteRoot + "job/" + jobId, { meta: meta })
            return response?.data;
        },
        ...machinejobApi.methods,
        ...jobListApi.methods,
        async GetHazardAnalysisLink(jobid, open) {
            var meta = { clientApiMethod: 'GetHazardAnalysisLink', input: { jobid: jobid } }
            var response = await client().get('api2/resource/' + "hazard-analysis/" + jobid, { meta: meta })
                .then((response) => {
                    if (open) { window.open(response.data, "_blank") }
                    return response;
                })
            return response?.data;
        },
        //JOB SERVICE REPORT
        GetServiceReportLink(jobid, open) {
            var newurl = window.location.origin + "/ServiceProviderWebSite/Views/Reports/?jobid=" + jobid;
            //console.log('GetServiceReportLink = ', newurl)
            if (open) {
                window.open(newurl, "_blank");
            }
            return newurl;
        },
    }
}